import { Grid } from '@mui/material';

interface IUserListView {
  children: React.ReactNode;
  toggle?: boolean;
  className?: any;
}

const UserListView = ({ toggle = false, children, className='' }: IUserListView) => {
  return (
    <Grid
      item
      container
      sx={{
        padding: '0px',
        overflow: 'auto',
        background: toggle ? 'white' : '#F5F5F5',
        borderRadius: '8px ',
      }}
      className={`users-list ${className}`}
    >
      {children}
    </Grid>
  );
};

export default UserListView;
